import script from "./OidoSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./OidoSelect.vue?vue&type=script&setup=true&lang=js"

import "./OidoSelect.vue?vue&type=style&index=0&id=f0aadd20&scoped=true&lang=css"
import "./OidoSelect.vue?vue&type=style&index=1&id=f0aadd20&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0aadd20"]])

export default __exports__